module.exports = __webpack_public_path__ + "static/img/doomyoga-music-background.13978b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/doomyoga-music-background.png
// module id = i2iL
// module chunks = 0